import React, { Component } from "react";
import PropTypes from "prop-types";

const withRouterPageLayout = (ComposedComponent) => {
  class WithRouteWrapper extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    render() {
      return <ComposedComponent router={this.context.router} {...this.props} />;
    }
  }

  WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;

  // Hoists non standard static properties
  WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
  WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
  WithRouteWrapper.pageName = ComposedComponent.pageName;

  return WithRouteWrapper;
};

export default withRouterPageLayout;
